<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-5">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mb-1 mt-2">
                  {{ data.brd_name }}
                </h5>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Descriptions</h5>
            <p class="text-muted">
              {{ data.brd_description != null ? data.brd_description : "-" }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Products</h4>
              <template v-if="local_users.usr_admin != ''">
              <button
                type="button"
                class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                @click="qucikCreateShow(true)"
              >
                <i class="bx bx-plus mr-2"></i> Products
              </button>
              </template>
            </div>
            <!---->
            <div class="mt-3">
              <tables
                v-if="childDataLoaded"
                module="Produk"
                table_module="products"
                alias_table="prd"
                :data="data_prod"
                :fields="fields_prod"
                :local_users="local_users"
                @fetchData="fetchData"
                :hidden-checkbox="false"
                :sortable="{
                  orderBy: orderBy,
                  sort: sort,
                }"
              ></tables>
            </div>
          </div>
        </div>
      </div>
    </div>

    <quickCreate
      v-if="childDataLoaded"
      :visible="visible"
      :fields="fields_prod"
      module="Produk"
      table_module="products"
      alias_table="prd"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{ brd_id: data.brd_id }"
    ></quickCreate>
  </div>
</template>

<script>
import quickCreate from "@/components/quick_create";
import tables from "@/components/tables";

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Brand Produk",
      table_module: "brand",
      alias_table: "brd",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      childDataLoaded: false,
      fields_prod: {},
      data_prod: {},
    };
  },
  components: {
    tables,
    quickCreate,
  },
  mounted() {
    this.fetchDetail();
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.fetchData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    fetchData(arm) {
      this.fields_prod = {}
      this.visible = false;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: arm.page == undefined ? this.page : arm.page,
          show: arm.show == undefined ? this.show : arm.show,
          order_by: arm.orderBy == undefined ? this.orderBy : arm.orderBy,
          type_sort: arm.sort == undefined ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      params["filter[brd_id]"] = this.data.brd_id;

      this.axios.get("/products", { params: params }).then((response) => {
        this.fields_prod = response.data.data.fields;
        this.data_prod = response.data.data["products"];
        this.childDataLoaded = true;
      });
    },
  },
};
</script>